
import { FirearmStorageLocation } from './firearm-storage-location.model';
import { FirearmStorageLocationTypeInfoBase } from './firearm-storage-location.typeinfo.base';


export class FirearmStorageLocationTypeInfo extends FirearmStorageLocationTypeInfoBase {
  description(item: FirearmStorageLocation): string {
    return super.description(item) + (item.businessUnit?.national ? ' (National)' : '');
  }
}

export const FIREARM_STORAGE_LOCATION_TYPE: FirearmStorageLocationTypeInfo = new FirearmStorageLocationTypeInfo();



